module.exports = __webpack_public_path__ + "static/media/014_intel3_2.e116b338.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/014_intel3_2.png
// module id = 484
// module chunks = 0